/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetQuestionDto
 */
export interface GetQuestionDto {
    /**
     * 
     * @type {string}
     * @memberof GetQuestionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionDto
     */
    surveyId: string;
    /**
     * 
     * @type {number}
     * @memberof GetQuestionDto
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionDto
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionDto
     */
    questionEn: string;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionDto
     */
    responseType: GetQuestionDtoResponseTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionDto
     */
    optional: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionDto
     */
    expectedYesNoAnswer?: GetQuestionDtoExpectedYesNoAnswerEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionDto
     */
    blockOnWrongAnswer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionDto
     */
    warningLight: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionDto
     */
    active: boolean;
}


/**
 * @export
 */
export const GetQuestionDtoResponseTypeEnum = {
    Text: 'Text',
    YesNo: 'YesNo',
    YesNoText: 'YesNoText'
} as const;
export type GetQuestionDtoResponseTypeEnum = typeof GetQuestionDtoResponseTypeEnum[keyof typeof GetQuestionDtoResponseTypeEnum];

/**
 * @export
 */
export const GetQuestionDtoExpectedYesNoAnswerEnum = {
    Yes: 'Yes',
    No: 'No'
} as const;
export type GetQuestionDtoExpectedYesNoAnswerEnum = typeof GetQuestionDtoExpectedYesNoAnswerEnum[keyof typeof GetQuestionDtoExpectedYesNoAnswerEnum];


/**
 * Check if a given object implements the GetQuestionDto interface.
 */
export function instanceOfGetQuestionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "surveyId" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "question" in value;
    isInstance = isInstance && "questionEn" in value;
    isInstance = isInstance && "responseType" in value;
    isInstance = isInstance && "optional" in value;
    isInstance = isInstance && "blockOnWrongAnswer" in value;
    isInstance = isInstance && "warningLight" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetQuestionDtoFromJSON(json: any): GetQuestionDto {
    return GetQuestionDtoFromJSONTyped(json, false);
}

export function GetQuestionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'surveyId': json['surveyId'],
        'order': json['order'],
        'question': json['question'],
        'questionEn': json['questionEn'],
        'responseType': json['responseType'],
        'optional': json['optional'],
        'expectedYesNoAnswer': !exists(json, 'expectedYesNoAnswer') ? undefined : json['expectedYesNoAnswer'],
        'blockOnWrongAnswer': json['blockOnWrongAnswer'],
        'warningLight': json['warningLight'],
        'active': json['active'],
    };
}

export function GetQuestionDtoToJSON(value?: GetQuestionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'surveyId': value.surveyId,
        'order': value.order,
        'question': value.question,
        'questionEn': value.questionEn,
        'responseType': value.responseType,
        'optional': value.optional,
        'expectedYesNoAnswer': value.expectedYesNoAnswer,
        'blockOnWrongAnswer': value.blockOnWrongAnswer,
        'warningLight': value.warningLight,
        'active': value.active,
    };
}

